import React from "react";

/* Bootstrap Components */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

/* Others */
import logoBlack from "../../../assets/logo_solo.png";
import Modal from "react-modal";
import { FaRegWindowClose } from "react-icons/fa";
import {
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaSpotify,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  AiFillInstagram
} from "react-icons/ai"
// Styles
import {
  StyledUlList,
  StyledFooterCopyRight,
  StyledRowFooter,
  StyledFooter,
} from "./styled";
import "./style.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

function Footer() {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Row
      style={{
        background: "#E5E5E5",
        padding: "20px 40px",
        marginLeft: "0px",
        marginRight: "0px",
      }}
    >
      <StyledFooter xs={12} md={4} lg={4} xl={4}>
        <img src={logoBlack} alt="logo" className="logo" />
        <StyledUlList>
          <li>
            <a
              href="https://www.facebook.com/Chequeado"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <FaFacebook size={15} />
            </a>
          </li>
          <li>
            <a
              href="https://instagram.com/chequeado"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <AiFillInstagram size={20} />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/chequeado/"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <FaLinkedin size={15} />
            </a>
          </li>
          <li>
            <a
              href="https://www.chequeado.com/spotify"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <FaSpotify size={15} />
            </a>
          </li>
          <li>
            <a
              href="https://www.tiktok.com/@chequeado"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              {/* <FaTiktok size={15} /> */}
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/Chequeado"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <FaTwitter size={15} />
            </a>
          </li>
          <li>
            <a
              href="https://api.whatsapp.com/send?text=https://chequeado.com"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <IoLogoWhatsapp size={15} />
            </a>
          </li>

          <li>
            <a
              href="https://www.youtube.com/chequeado"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              <FaYoutube size={15} />
            </a>
          </li>
        </StyledUlList>
      </StyledFooter>
      <Col xs={12} md={8} lg={8} xl={8} style={{ textAlign: "right" }}>
        <StyledRowFooter>
          <Col xs={12} sm={6} md={2} lg={3} className="col-creditos">
            <div className="styledSupport">
              <span className="creditos">
                <span onClick={openModal} className="link-modal">
                  Créditos
                </span>
              </span>
            </div>
          </Col>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            ariaHideApp={false}
          >
            <Row>
              <Container>
                <Col lg={12} className="mx-auto">
                  <Row>
                    <Col style={{ textAlign: "right" }}>
                      <FaRegWindowClose
                        onClick={closeModal}
                        style={{
                          color: "#354052",
                          fontSize: "20px",
                          marginRight: "5px",
                          verticalAlign: "sub",
                          cursor: "pointer",
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        textAlign: "center",
                        marginBottom: "20px",
                        fontWeight: "bold",
                        color: "#dc4157",
                      }}
                    >
                      Créditos
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12} className="mx-auto">
                      <Row>
                        <Col lg={12}>
                          <ul className="styleUlCredits">
                            <li>
                              Coordinación de producto | <b>Ariel Tiferes</b>
                            </li>
                            <li>
                              Líder de Proyectos | <b>Sebastián Lanaro</b>
                            </li>
                            <li>
                              Diseño | <b>Matías Severo</b>
                            </li>
                            <li>
                              Desarrollo | <b>Pilar Castro</b>
                            </li>

                            <hr />
                            <li>
                              Dirección ejecutiva y periodístico |
                              <b>Pablo M. Fernández</b>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Container>
            </Row>
          </Modal>
        </StyledRowFooter>
        <StyledFooterCopyRight>
          Chequeado · copyright (c) 2022{" "}
        </StyledFooterCopyRight>
      </Col>
    </Row>
  );
}

export default Footer;
